import React from "react";
import { toast } from "react-toastify";
import { useTheme, Divider, Chip, Button, Box } from "@mui/material";

import { auth, signInWithEmail } from "../../helpers/firebase";

import SimpleBox from "../../components/layout/container/SimpleBox";
import PasswordInput from "../../components/input/text/PasswordInput";
import EmailInput from "../../components/input/text/EmailInput";
import DefaultLink from "../../components/link/DefaultLink";
import GoogleButton from "../../components/input/button/GoogleButton";
import UserContainer from "../../components/layout/container/UserContainer";

const Login = () => {

    const theme = useTheme();

    const [email, setEmail] = React.useState(null);
    const [password, setPassword] = React.useState(null);
    const [errors, setErrors] = React.useState({email: null, password: null});

    const handleSubmit = () => {
        const newErrors = {email: null, password: null};
        if (email === null || email === "") { newErrors.email = "Por favor, preencha o email"; }
        if (password === null || password === "") { newErrors.password = "Por favor, preencha a password"; }
        setErrors(newErrors);

        if (newErrors.email !== null || newErrors.password !== null) { return; }

        signInWithEmail(email, password, ({ user, error }) => {
            if (error !== null) {
                let message = "";
                switch (error.code) {
                    case "auth/invalid-credential":
                        message = "O email e password estão incorretos.";
                        break;
                    case "auth/invalid-email":
                        message = "O email não é válido.";
                        break;
                    case "auth/user-disabled":
                        message = "O utilizador foi desativado.";
                        break;
                    case "custom/user-disabled":
                        message = "O utilizador não se encontra ativo. Verifique o seu email para ativar a conta. Confirme se o email não está na pasta de spam e contacte-nos se não tiver recebido o email.";
                        break;
                    default:
                        message = "Ocorreu um erro ao entrar na conta. Por favor, tente novamente mais tarde ou contacte-nos.";
                        break;
                }
                toast.error(message, {autoClose: 10000});
                return;
            }
            toast.success("Utilizador autenticado com sucesso!");
        });
    }

    return (
        <UserContainer
            title="Autenticação"
            message="Autentique-se no site da ADCB para ter acesso às funcionalidades de sócio e de atleta. Ou crie uma nova conta."
        >
            <Box mt={theme.spacing(4)} gap={theme.spacing(4)} display="flex" flexDirection="column">
                <GoogleButton />
                <Divider><Chip label="OU" size="small" /></Divider>
                <SimpleBox gap={4} flexDirection="column" alignItems="left">
                    <EmailInput value={email} errorText={errors.email} onChange={(e) => { setEmail(e.target.value); setErrors({...errors, email: null}) }} />
                    <PasswordInput value={password} errorText={errors.password} onChange={(e) => { setPassword(e.target.value); setErrors({...errors, password: null}) }} />
                    <Button variant="contained" color="primary" fullWidth={true} onClick={handleSubmit}>Entrar</Button>
                    <SimpleBox justifyContent="space-between">
                        <DefaultLink label="Esqueci-me da password" to="/forgot-password" fontSize="0.95rem" allCaps={true} />
                        <DefaultLink label="Criar Conta" to="/register" fontSize="0.95rem" allCaps={true} />
                    </SimpleBox>
                </SimpleBox>
            </Box>
        </UserContainer>
    );
};

export default Login;
